import { render } from "./developerdetailsmodal.vue?vue&type=template&id=5dd8fbf2"
import script from "./developerdetailsmodal.vue?vue&type=script&lang=js"
export * from "./developerdetailsmodal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__